import { render, staticRenderFns } from "./ClientsTable.vue?vue&type=template&id=94796a62"
import script from "./ClientsTable.vue?vue&type=script&lang=js"
export * from "./ClientsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports